import { LoginOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAccount } from '../../components/contexts/AccountContextManager';
import HeaderLogo from '../HeaderLogo';
import HeaderMenu from './HeaderMenu';
import { Header, HeaderContainer } from './styled';
import useBasicLayout from './useBasicLayout';

const BasicHeader = () => {
    const { t } = useTranslation();
    const user = useAccount(true);
    const navigate = useNavigate();
    const { withAdminButton } = useBasicLayout();

    const renderAdminButton = () => {
        if (user) {
            return (
                <Button icon={<LoginOutlined />} onClick={() => navigate('/admin')} type="dashed">
                    {t('common:goToPrivate')}
                </Button>
            );
        }

        return (
            <Button onClick={() => navigate('/auth/signIn')} type="primary">
                {t('common:signIn')}
            </Button>
        );
    };

    const adminButton = withAdminButton ? renderAdminButton() : null;

    return (
        <Header>
            <HeaderContainer>
                <HeaderLogo link="/" />
                <HeaderMenu />
                {adminButton}
            </HeaderContainer>
        </Header>
    );
};

export default BasicHeader;
